import React from 'react'
import classNames from 'classnames'
import { Image } from '@deal/components'
import {
  MediaFileFragment,
  ConsumerSellableReactionFragment,
  ConsumerSellableReactionRating
} from '#src/generated/graphql'
import SliderWithScrollLock, { SlickSlider } from '#src/components/SliderWithScrollLock'
import LightBox from './LightBox'
import SellableReactions from '../SellableReactions'
import styles from './styles.css'

interface ProductImageCarouselProps {
  currentSlide: number
  images: MediaFileFragment[]
  sampleImageIds: string[]
  onNavigateToSlide: (index: number) => void
  isSmall?: boolean
  sellableReactions?: ConsumerSellableReactionFragment[]
  onSellableRatingSelected: (rating: ConsumerSellableReactionRating) => void
  openFeedbackModal?: () => void
}

class ProductImageCarousel extends React.Component<ProductImageCarouselProps> {
  public slider: React.RefObject<SlickSlider>

  public constructor(props: ProductImageCarouselProps) {
    super(props)

    this.slider = React.createRef()
  }

  public componentWillUpdate(props: ProductImageCarouselProps) {
    if (this.slider && this.slider.current) {
      this.slider.current.slickGoTo(props.currentSlide)
    }
  }

  public render() {
    const {
      sampleImageIds,
      images,
      onNavigateToSlide,
      isSmall,
      sellableReactions,
      onSellableRatingSelected,
      openFeedbackModal
    } = this.props

    return (
      <div className={styles.container}>
        <div
          className={classNames(styles.sliderContainer, { [styles.sliderContainerSmall]: isSmall })}
        >
          <SliderWithScrollLock
            sliderRef={this.slider}
            slidesToShow={1}
            slidesToScroll={1}
            arrows={false}
            infinite={true}
            dots={true}
            speed={400}
            className={styles.slider}
            dotsClass={styles.dots}
            waitForAnimate={false}
            afterChange={index => onNavigateToSlide(index)}
          >
            {images.map(image => {
              const isSampleImage = sampleImageIds.includes(image.id)
              return (
                <div className={styles.imageContainer} key={image.id}>
                  <Image lazyLoad={false} src={image.url} width={500} className={styles.slide} />
                  {isSampleImage && <div className={styles.sampleImage}>Sample image</div>}
                </div>
              )
            })}
          </SliderWithScrollLock>
          {images.length > 1 && <LightBox images={images.map(({ url }) => url)} />}
          <div className={styles.desktopOnly}>
            <SellableReactions
              onSellableRatingSelected={onSellableRatingSelected}
              sellableReactions={sellableReactions}
              openFeedbackModal={openFeedbackModal}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ProductImageCarousel
